module.exports = __webpack_public_path__ + "svg/file-detailed-pdf.013475af869c712d9bb5f57186b27afb.svg";